import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  widgetContainer: {
    px: 1,
    py: 1,

    '&.widgetHidden': {
      display: 'none',
    },
  },

  widget:
    (
      backgroundColor?: string | null,
      fontWeight?: string | null,
      fontSize?: number | null,
    ) =>
    (theme: Theme) => ({
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: backgroundColor || theme.colors.white,
      flexGrow: '1',
      transition: 'box-shadow .5s',
      borderRadius: '6px',
      ...(fontWeight ? { fontWeight } : {}),
      ...(fontSize ? { fontSize } : {}),

      // apply box-shadow on non-transparent widgets
      ...(backgroundColor !== 'transparent' && {
        boxShadow: `0 4px 18px ${alpha(theme.colors.black, 0.1)}`,
        '&:hover': {
          boxShadow: `0 4px 18px ${alpha(theme.colors.black, 0.2)}`,
        },
        '&.widget-highlight': {
          boxShadow: `0 4px 18px ${alpha(theme.colors.primary[500], 0.2)}`,
        },
      }),
    }),
};
